import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Needle = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="needle icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.0001 8.00002L16.929 0.928955L14.8077 3.05028L17.2679 5.51044L15.8683 6.90997L11.9792 3.02081L9.85786 5.14213L11.2721 6.55638L11.2574 6.57109L4.18633 13.6422L2.06501 15.7635L2.06507 15.7635L4.18633 17.8848L4.53985 18.2383L0.650766 22.1274C0.0649792 22.7132 0.0649792 23.663 0.650766 24.2488C1.23655 24.8345 2.1863 24.8345 2.77209 24.2488L6.66117 20.3597L7.01476 20.7132L9.13608 22.8345L9.13614 22.8346L14.7889 17.1818L14.7888 17.1818L18.3285 13.6422L18.3432 13.6274L19.7574 15.0416L21.8787 12.9203L17.9897 9.03129L19.3892 7.63176L21.8788 10.1213L24.0001 8.00002ZM13.3787 8.69241L16.2071 11.5208L12.6675 15.0605L9.83909 12.232L13.3787 8.69241Z"
    />
  </svg>
)
